/* limit-one-ref.js — Prestige */
const RULES = [
  { by: 'product_id', value: 15440729538938 },  // limite TOUTES les variantes de ce produit
  { by: 'sku',        value: 'LXHHA2025' }      // filet de sécurité par SKU
];

function matchesRule(it) {
  return RULES.some(r => {
    switch (r.by) {
      case 'product_id': return Number(it.product_id) === Number(r.value);
      case 'variant_id': return Number(it.id) === Number(r.value) || Number(it.variant_id) === Number(r.value);
      case 'sku':        return String(it.sku || '') === String(r.value);
      case 'handle':     return String(it.handle || '') === String(r.value);
      default: return false;
    }
  });
}

async function getCart(){ return fetch('/cart.js').then(r=>r.json()); }

async function enforceLimit(cartArg){
  const cart = cartArg || await getCart();
  const restrictedIdx = [];
  let total = 0;

  cart.items.forEach((it, idx) => {
    if (matchesRule(it)) { restrictedIdx.push(idx); total += it.quantity; }
  });

  if (total <= 1) return false;

  // On reconstruit les quantités en 1 seul appel /cart/update.js
  const updates = cart.items.map(it => it.quantity);
  restrictedIdx.forEach((idx, i) => { updates[idx] = (i === 0 ? 1 : 0); });

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({ updates })
  });

  // Rafraîchit drawer, compteurs, etc. (événement officiel Prestige)
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  return true;
}

let busy = false;
async function tick(cart){
  if (busy) return;
  busy = true;
  try { await enforceLimit(cart); } finally { busy = false; }
}

// 1) Au chargement
tick();

// 2) À chaque MAJ du panier (événements Prestige v7+)
document.addEventListener('cart:change',       e => tick(e.detail?.cart));
document.addEventListener('variant:add',       e => tick(e.detail?.cart));
document.addEventListener('line-item:change',  e => tick(e.detail?.cart));
